(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rr-carousel]').forEach(function (root) {
    if (root.dataset.rrReady) return;
    root.dataset.rrReady = '1';
    var track = root.querySelector('[data-rr-track]');
    var prev = root.querySelector('[data-rr-prev]');
    var next = root.querySelector('[data-rr-next]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-scrollable', max > 4);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    function page(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
